import {
  Column,
  TableCellRenderer
} from "react-table";
import * as React from "react";

import * as globalTableColumns from "src/core/shared/components/TableGlobalColumns";
import { IProcessJob } from "src/core/process-job/api/processJobs.api";

import ConnectorSyncStatusStyled from "../components/ErpSyncStatus";

export interface ITableColumnParams {
  ActionButton: TableCellRenderer;
}

export const connectorOrderImportIssueTableColumns = (params: ITableColumnParams): Array<Column<IProcessJob>> => {
  const columns: Array<Column<IProcessJob>> = [
    globalTableColumns.id({ header: "Job ID" }),
    globalTableColumns.id({
      accessor: "orderId",
      header: "Order ID"
    }),
    globalTableColumns.standardText({
      Header: "API status",
      accessor: "order.erpSyncStatus",
      filterable: false,
      sortable: false,
      Cell: row => {
        return <ConnectorSyncStatusStyled status={row.value} />;
      }
    }),
    globalTableColumns.date({
      header: "Last attempt",
      accessor: "finishedAt",
      template: "datetime"
    }),
    globalTableColumns.date({
      header: "Auto retry",
      accessor: "autoRetry",
      template: "datetime"
    }),
    globalTableColumns.standardText({
      Header: "Error message",
      accessor: "statusMessage",
      width: 300
    }),
    globalTableColumns.date({
      header: "Delivery Date",
      accessor: "order.orderDeliveryDate",
      ignoreLocal: true,
      filterable: false,
      sortable: false
    }),
    globalTableColumns.standardText({
      Header: "API ID",
      accessor: "jobData.externalId",
      sortable: false,
      filterable: false
    }),
    globalTableColumns.actions({
      cell: params.ActionButton,
      width: 200
    })
  ];

  return columns;
};
